import { addClass, removeClass, removeNode } from '@utils/domUtils';

export default class JobAdContent {
  static selectorString() {
    return '.JobAdContent';
  }

  render(node, props) {
    this.jobTitle = node.querySelector('[data-prop="title"]');
    this.jobTitleWrap = node.querySelector('.job-ad-title-text');
    this.image = node.querySelector('[data-prop="image"]');
    this.attachmentsSection = node.querySelector('[data-prop="attachments"]');
    this.attachmentsTitle = node.querySelector('[data-prop="attachmentsTitle"]');
    this.attachmentsList = node.querySelector('[data-prop="attachmentsList"]');

    this.sections = [...node.querySelectorAll('[data-prop="section"]')];
    this.sections.forEach(element => {
      const sectionId = element.getAttribute('data-section');
      element.sectionId = sectionId;
      element.titleNode = element.querySelector('[data-prop="sectionTitle"]');
      element.descriptionNode = element.querySelector('[data-prop="sectionDescription"]');
    });

    this.attachmentItemTemplate = node.querySelector('.attachment-item-template');
    removeNode(this.attachmentItemTemplate);
    removeClass(this.attachmentItemTemplate, 'attachment-item-template');
    removeClass(this.attachmentItemTemplate, 'hide');
  }

  setJobAdImage(url) {
    if (typeof url === 'string' && url.length > 0) {
      this.image.style.backgroundImage = `url(${url})`;
      removeClass(this.image, 'empty');
    } else {
      this.image.style.backgroundImage = '';
      addClass(this.image, 'empty');
    }
  }

  setData(data) {
    if (data.jobTitle && data.jobTitle.length > 0) {
      removeClass(this.jobTitleWrap, 'hide');
      this.jobTitle.innerHTML = data.jobTitle;
    } else {
      addClass(this.jobTitleWrap, 'hide');
    }

    this.sections.forEach(element => {
      const title = data[`${element.sectionId}[title]`];
      const description = data[`${element.sectionId}[description]`];

      const visible =
        data[`${element.sectionId}[visible]`] !== false &&
        (title.length > 0 || description.length > 0);

      // only if visibility is explicitly set to false
      // i.e. if not set at all, show block by default
      if (visible === false) {
        addClass(element, 'hide');
      } else {
        removeClass(element, 'hide');
      }

      if (title.length > 0) {
        removeClass(element.titleNode.parentNode, 'hide');
        element.titleNode.innerHTML = title;
      } else {
        addClass(element.titleNode.parentNode, 'hide');
      }

      if (description.length > 0) {
        removeClass(element.descriptionNode.parentNode, 'hide');
        element.descriptionNode.innerHTML = description;
      } else {
        addClass(element.descriptionNode.parentNode, 'hide');
      }
    });

    if (data.attachmentsTitle.length > 0) {
      removeClass(this.attachmentsTitle.parentNode, 'hide');
      this.attachmentsTitle.innerHTML = data.attachmentsTitle;
    } else {
      addClass(this.attachmentsTitle.parentNode, 'hide');
    }

    if (data.uploadedAttachments.length > 0) {
      this.attachmentsList.innerHTML = '';
      data.uploadedAttachments.forEach(file => {
        const attachment = this.attachmentItemTemplate.cloneNode(true);
        // TODO: implement modal that renders a message like "Sie müssen die Änderungen erst abspeichern um die ausgewählte Datei aufrufen zu können."
        attachment
          .querySelector('[data-prop="link"]')
          .setAttribute('href', file.src || 'javascript:void(0);');
        attachment.querySelector('[data-prop="filename"]').innerHTML = file.name;

        if (!file.src) {
          attachment.querySelector('[data-prop="link"]').removeAttribute('target');
        }

        this.attachmentsList.appendChild(attachment);
      });

      removeClass(this.attachmentsSection, 'hide');
    } else {
      addClass(this.attachmentsSection, 'hide');
    }
  }
}
